import { key } from 'core-ts-types';

const IDBStore: any = require('./lib/idbstore');

export * from './core/table';
import { Table, ITable } from './core/table';

export interface ILocalDatabase extends ITable<any> {

}

window['localTable'] = new Table<any>('local');



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-database/dist/main.ts